import { motion } from "framer-motion";
import * as cx from "classnames/bind";
import { Button, Input, Loader, Select, Icon } from "components";
import InputContainer from "components/atoms/Input/InputContainer";
import { useRecipeLists, useSession } from "hooks";
import Image from "next/legacy/image";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import s from "styles/Gallery.module.scss";
import { imageUrl, uniqObjArray, uniqObjArrayOld } from "utils";
import { useRouter } from "next/router";

const Cocktail = ({
  cocktail,
  user,
  setShowCreateListModal,
  setShowLoginModal,
  setLoginModalState,
  layout = true,
  prefetch = true,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const [isShown, setIsShown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [opacity, setOpacity] = useState(cocktail.name ? 1 : 0);
  const router = useRouter();

  const toggle = () => {
    setIsShown(!isShown);
  };
  const toggleList = () => {
    setIsOpen(!isOpen);
  };

  const { data: session, status } = useSession();

  const recipe = (cocktail.recipes || [{}])[0] || {};
  const ingredients = cocktail.ingredients
    ? uniqObjArrayOld(cocktail.ingredients)
    : uniqObjArray(
        ((recipe.timeline || {}).steps || []).flatMap(
          (step) => step.ingredients,
        ) || cocktail.ingredients,
      );

  const bartenderViews = Math.floor(props.randomVal * (100 - 10 + 1)) + 10;
  const totalPrice = Math.floor(props.randomVal * (10 - 5 + 1)) + 5;
  const recommendedPrice = Math.floor(props.randomVal * (16 - 4 + 1)) + 8;

  const cocktailSpirits = (cocktail.spirits || []).map((s) => s.spirit || s);
  const spirits =
    cocktailSpirits.length > 0
      ? cocktail.spirits
          .map((s) => s.spirit || s)
          .filter((s) => !s.search_only)
          .map((s) => cocktailSpirits.find((o) => o.id == s.parent_id) || s)
      : ingredients.filter((i) => i.type == "spirit"); // && !!!i.parent_id)

  const mainSpirits = spirits.map((s) => s.name);

  const cocktailIngredients = spirits.concat(
    ingredients.filter((i) => !spirits.find((s) => s.id == i.id)),
  );

  const cocktailId =
    cocktail.id || parseInt(cocktail.objectID) || cocktail.objectID;
  useEffect(() => {
    setOpacity(cocktail.name ? 1 : 0);
  }, [cocktail]);
  const { recipeLists, setRecipeLists } = useRecipeLists();
  const isInList = !!recipeLists
    .flatMap((list) => list.items)
    .find((cId) => cId == cocktailId);

  const toggleRecipeList = async (selected, list) => {
    const newLists = recipeLists.map((l) => {
      return l.name != list.name
        ? l
        : {
            ...l,
            items: l.items
              .filter((cId) => cId != cocktailId)
              .concat(selected ? [cocktailId] : []),
          };
    });
    await setRecipeLists(newLists);
    setIsShown(false);
  };
  /*
      itemProp="itemListElement"
      itemScope
      itemType="http://schema.org/Recipe"
      */
  return (
    <div
      className={cx("GalleryFeedItem  rowItem", s.GalleryFeedItem, className)}
      key={cocktailId}
      layoutId={
        props.layoutSuffix
          ? `${cocktailId}-${props.layoutSuffix || ""}`
          : cocktailId
      }
      layout={layout}
      {...props}
    >
      <div className={cx("favContainer", s.favContainer)}>
        {cocktailIngredients.length > 0 ? (
          <button
            infoBtn="true"
            className={cx("infoBtn", s.infoBtn, isOpen ? "open" : "")}
            onClick={toggleList}
          ></button>
        ) : (
          <></>
        )}
        {session?.user ? (
          <button
            favBtn="true"
            className={cx("favBtn", s.favBtn, isInList ? "in-list" : "")}
            onClick={toggle}
          ></button>
        ) : (
          <button
            favBtn="true"
            className={cx("favBtn", s.favBtn)}
            onClick={() =>
              setLoginModalState({
                show: true,
                message: t(
                  "Please log in or register an account to create menus",
                ),
                index: 0,
              })
            }
          ></button>
        )}
        <div className={cx("favList", s.favList, isShown ? "open" : "")}>
          <div
            className={cx("favListOverlay", s.favListOverlay)}
            onClick={toggle}
          ></div>
          <div className={cx("favListHeader", s.favListHeader)}>
            <b>
              <span>{cocktail.name} - </span>
              {t("Add to menu")}:
            </b>
            <button
              className={cx("closeBtn", s.closeBtn)}
              onClick={toggle}
              title={t("Close")}
            ></button>
          </div>
          <ul>
            {recipeLists.map((list, index) => (
              <li key={index} className="checkContainer">
                <label>
                  <input
                    type="checkbox"
                    checked={!!list.items.find((cId) => cId == cocktailId)}
                    onChange={(e) => toggleRecipeList(e.target.checked, list)}
                  />
                  {list.name}
                </label>
              </li>
            ))}
            {recipeLists.length > 0 ? (
              <></>
            ) : (
              <li className="checkContainer">
                <label>{t("Your menu list is empty.")}</label>
              </li>
            )}
          </ul>
          <Button
            className={cx(
              "Full Rad0 noFocus",
              recipeLists.length > 0 ? "" : "Bold Cyan",
            )}
            onClick={() => setShowCreateListModal(true)}
          >
            {t("Create menu")}&nbsp;+
          </Button>
        </div>
        {cocktailIngredients.length > 0 ? (
          <div className={cx("infoList", s.infoList, isOpen ? "open" : "")}>
            <div
              className={cx("infoListOverlay", s.infoListOverlay)}
              onClick={toggleList}
            ></div>
            <div className={cx("infoListHeader", s.infoListHeader)}>
              <b>
                <span>{cocktail.name} - </span>
                {t("Ingredients needed")}:
              </b>
              <button
                className={cx("closeBtn", s.closeBtn)}
                onClick={toggleList}
              ></button>
            </div>
            <ul>
              {cocktailIngredients.map((ingredient, index) => (
                <li key={index}>{ingredient.name}</li>
              ))}
            </ul>
          </div>
        ) : (
          <></>
        )}
      </div>
      <Link
        href={props.href || `/cocktails/${cocktail.slug}`}
        itemProp="url"
        prefetch={prefetch}
      >
        <div className={cx("GalleryImageWrapper p0", s.GalleryImageWrapper)}>
          <Image
            src={imageUrl(cocktail.image?.id || cocktail.image_id || "")}
            layout="responsive"
            width={350}
            height={450}
            objectFit="cover"
            itemProp="image"
            alt={cocktail.name}
          />
        </div>
        <header>
          <p>{mainSpirits.slice(0, 1).join(", ") || "non-alc"}</p>
          <h4 itemProp="name" className="title">
            {cocktail.name}
          </h4>
          <span>
            {recipe && recipe.timeline && recipe.timeline.duration
              ? `${recipe.timeline.duration} mins / `
              : ""}
            {(cocktail.difficulty || {}).name || ""}
          </span>
        </header>
      </Link>
      {!user?.barTender && (
        <>
          {props.info && (
            <div
              style={{ paddingTop: "10px", textAlign: "center" }}
              horecaInfo="true"
            >
              {/*
              <p>Bartender veiws: {bartenderViews}</p>
              <p>Tot. ingredient price: {totalPrice}€</p>
              <p>Rec. sale price: {recommendedPrice}€</p>
              */}
            </div>
          )}
          {props.onDelete && !user?.barTender && (
            <button
              style={{ color: "#ac2323", width: "100%" }}
              removeFromMenuBtn="true"
              onClick={() => {
                props.onDelete(cocktail);
              }}
            >
              <small>Remove from menu</small>
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Cocktail;
